import { useEffect, useLayoutEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useFieldArray, useForm } from "react-hook-form";
import Loading from "../../../components/loading/Loading";
import PageTitle from "../../../components/titles/PageTitle";
import SecondContainer from "../../../components/container/SecondContainer";
import {
  getProject,
  saveDonorAgreements,
  unsetSelectedProject,
} from "../../../features/projectsSlice";
import { formatCurrency } from "../../../util";
import { useNotification } from "../../../components/notification/NotificationContainer";
import ResourseButtons from "../../../components/form/buttons/ResourseButtons";
import { Save } from "lucide-react";
import loadStatus from "../../../util/loadStatus";
import NetworkError from "../../error/NetworkError";

const ProjectAgreements = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const project = useSelector((state) => state.projects.selected);
  const projectLoad = useSelector((state) => state.projects.load.getProject);
  const saveAgeementLoad = useSelector(
    (state) => state.projects.load.saveDonorAgreements
  );
  const addNotification = useNotification();
  const {
    register,
    reset,
    watch,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const { fields } = useFieldArray({ name: "donors", control });

  const watchDonors = watch("donors") || [];

  const onSave = async (data) => {
    try {
    } catch (error) {}
  };

  const onSubmit = async (data) => {
    try {
      const dataTransfer = new DataTransfer();

      const donors = data.donors.map((i) => {
        return i.id;
      });

      const res = await dispatch(
        saveDonorAgreements({
          id: id,
          data: {
            donors,
            files: data.donors.map((i) => (i.file ? i.file[0] : null)),
          },
        })
      );
      if (saveDonorAgreements.fulfilled.match(res)) {
        addNotification(res.payload.message, "success");
        navigate("/projects/reformulations");
      } else if (saveDonorAgreements.rejected.match(res)) {
      } else {
        addNotification(res.payload.message, "error");
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };
  useLayoutEffect(() => {
    dispatch(getProject(id));

    return () => {
      dispatch(unsetSelectedProject());
    };
  }, []);

  // useEffect(() => {
  //   if (project.id) {
  //   }
  // }, [project]);

  useEffect(() => {
    watch(fields?.map((_, index) => `donors.[${index}].file.length`));
  }, [watch, watchDonors, fields, `donors`]);

  if (projectLoad === loadStatus.loading) {
    return <Loading />;
  }

  if (projectLoad === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <>
      <SecondContainer className="  ">
        <PageTitle title="Agreements with donors" />
        <div className="mb-7">Project : {" " + project.name}</div>
        <form onSubmit={handleSubmit(onSubmit)}>
          {project.id && (
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <td className="p-2 bg-gray-600 text-white">No.</td>
                    <td className="p-2 bg-gray-600 text-white">Donor</td>
                    <td className="p-2 bg-gray-600 text-white">Amount</td>
                    <td className="p-2 bg-gray-600 text-white">File</td>
                    {/* <td className="p-2 bg-gray-600 text-white">Action</td> */}
                  </tr>
                </thead>
                <tbody>
                  {project.donors.map((item, index) => (
                    <tr key={index}>
                      {/* <form
                        key={index}
                        onSubmit={handleSubmit(onSave)}
                        className="h-6 bg-green-500"
                      > */}
                      <td className="p-2">{index + 1}</td>
                      <td className="p-2">{item.donor?.name}</td>
                      <td className="p-2">{item.amount}</td>
                      <td className="p-2">
                        <input
                          type="file"
                          accept="application/pdf"
                          {...register(`donors.[${index}].file`)}
                        />
                        <input
                          type="hidden"
                          {...register(`donors.[${index}].id`)}
                          value={item.donor_id}
                        />
                      </td>
                      {/* <td className="p-2">
                        <button
                          onClick={(e) => onSave(index)}
                          type="button"
                          className="text-primary disabled:text-gray-400"
                          disabled={
                            !watchDonors[index]?.file ||
                            watchDonors[index]?.file.length <= 0
                          }
                        >
                          <Save />
                        </button>
                      </td> */}
                      {/* </form> */}
                    </tr>
                  ))}
                  <tr>
                    <td className="p-2">Total</td>
                    <td className="p-2"></td>
                    <td colSpan={1}>
                      {formatCurrency(
                        project.donors
                          .map((i) => i.amount)
                          .reduce((acc, cur) => Number(cur) + acc, 0)
                      )}
                    </td>
                    <td className="p-2"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
          <ResourseButtons
            loading={saveAgeementLoad}
            text="Back"
            link="/projects/reformulations"
          />
        </form>
      </SecondContainer>
    </>
  );
};

export default ProjectAgreements;
